import { Avatar } from '@synoptic/ui-kit/avatar/avatar.js';
import { CardLink } from './card-link';
import dummyAvatar from './dln.webp';
import { cardFooter, cardFooterLeft } from './card-footer.css';
import { cardAvatar } from './cards.css';

type CardFooterProps = {
  username: string;
  avatarSrc?: string | null;
  year?: string;
};

export const CardFooter = ({
  username,
  avatarSrc = dummyAvatar,
  year = '2026',
}: CardFooterProps) => {
  return (
    <div className={cardFooter}>
      <CardLink href={`https://x.com/${username}`} className={cardFooterLeft}>
        <Avatar size="small" imageSrc={avatarSrc} className={cardAvatar} />
        <span>@{username}</span>
      </CardLink>
      {year}

      <CardLink href={'https://synoptic.com/ct-stats'}>
        synoptic.com/ct-stats
      </CardLink>
    </div>
  );
};
